import { Job } from "../model/JobModel";
import { JobFormErrors } from "./job.reducer";

export const validateJobForm = (data: Partial<Job>): JobFormErrors => {
  const errors: JobFormErrors = {};
  if (!data.title || data.title.trim().length === 0) {
    errors.title = "Title is required";
  } else if (data.title.trim().length < 3) {
    errors.title = "Title must be at least 3 characters";
  }
  if (!data.description || data.description.trim().length === 0) {
    errors.description = "Description is required";
  } else if (data.description.trim().length < 50) {
    errors.description = "Description must be at least 50 characters";
  }

  if (!data.department) {
    errors.department = "Department is required";
  }

  if (!data.recruiter_name || data.recruiter_name === "") {
    errors.recruiter_name = "Recruiter is required";
  }
  if (!data.hiring_manager_name || data.hiring_manager_name === "") {
    errors.hiring_manager_name = "Hiring Manager is required";
  }

  if (!data.location) {
    errors.location = "Location is required";
  }

  if (!data.job_type) {
    errors.job_type = "Job type is required";
  }
  if (!data.posting_visibility) {
    errors.posting_visibility = "Posting visibility is required";
  }
  const min = data.salary_min;
  const max = data.salary_max;

  if (min && !max) {
    errors.salary_max =
      "Maximum salary is required when minimum salary is provided";
  }


  if (min && max && Number(min) > Number(max)) {
    errors.salary_max = "Max salary must be greater than min salary";
  }
  // if (
  //   data.salary_min &&
  //   data.salary_max &&
  //   Number(data.salary_min) > Number(data.salary_max)
  // ) {
  //   errors.salary_max = "Max salary must be greater than min salary";
  // }

  return errors;
};
